import { useTranslate } from "@pankod/refine-core";
import {
	useForm,
	Form,
	useSelect,
	Select,
	Create,
	Input,
	Radio,
} from "@pankod/refine-antd";
import { IExperimentalStudyStage, IExperimentalStudy } from "interfaces";

export const ExperimentalStudyCreate = () => {
	const translate = useTranslate();
	const { formProps, saveButtonProps, queryResult } =
		useForm<IExperimentalStudy>();

	const { selectProps: stageSelectProps } = useSelect<IExperimentalStudyStage>({
		resource: "experimental_studies_stages",
		defaultValue: queryResult?.data?.data?.stage_id,
		optionLabel: "name",
		optionValue: "id",
	});

	return (
		<Create
			isLoading={queryResult?.isLoading}
			saveButtonProps={saveButtonProps}
		>
			<Form {...formProps} layout="vertical">
				<Form.Item
					label={translate("experimental_studies.fields.stage.title")}
					name="stage_id"
					rules={[{ required: true }]}
				>
					<Select {...stageSelectProps} />
				</Form.Item>

				<Form.Item
					label={translate("experimental_studies.fields.name")}
					name="name"
					rules={[{ required: true }]}
				>
					<Input />
				</Form.Item>

				<Form.Item
					label={translate("experimental_studies.fields.description")}
					name="description"
					rules={[{ required: true }]}
				>
					<Input />
				</Form.Item>

				<Form.Item
					label={translate("experimental_studies.fields.url")}
					name="url"
					rules={[{ required: true }]}
				>
					<Input />
				</Form.Item>

				<Form.Item
					label={translate("experimental_studies.fields.is_visible")}
					name="is_visible"
				>
					<Radio.Group>
						<Radio value={true}>Sì</Radio>
						<Radio value={false}>No</Radio>
					</Radio.Group>
				</Form.Item>
			</Form>
		</Create>
	);
};
